import { useContext, createContext } from 'react';

import type { ApiConfigurationProps } from '../types';

export const apiConfigurationContext = createContext<ApiConfigurationProps>({
  apiConfiguration: undefined,
  isApiConfigurationLoading: false,
});

export const ApiConfigurationContextProvider = apiConfigurationContext.Provider;

export const useApiConfiguration = () => useContext(apiConfigurationContext);
